import React from "react";
import { Helmet } from "react-helmet";
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss');

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>March Wine Dinner</h1>
                <h2>
                  March 6 <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;|&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;|&nbsp;</span> $55 Per Guest
                </h2>
                <h4>For Reservations: <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
                <h5>First Course</h5>
                <h4>Spring Salad</h4>
                <p>Mixed Greens, Strawberries, Pecans, Ricotta, Chocolate Vinaigrette</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Mary Taylor Bourdeaux Blanc</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Sweet Louisiana BBQ Shrimp</h4>
                <p>Gulf Shrimp, Spicy Sweet Potato Purée</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Mary Taylor Agenais Rosé</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Salmon Wellington</h4>
                <p>Root Vegetable Ragout, Lemon Dill Aioli</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Mary Taylor Anjou Rouge</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Chocolate Bananas Foster</h4>
                <p>Crispy Cinnamon Sugar Bowl</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Mary Taylor Veneto Frizzante</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default wineDinner;